import React, { useContext, useState, useEffect, useCallback } from 'react';
import { auth } from '../firebase';
import { firebase } from '../firebase';

const AuthContext = React.createContext({});

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true);

  // idle timeout: 80 minutes (in ms)
  const IDLE_TIMEOUT = 80 * 60 * 1000; 
  const [lastActive, setLastActive] = useState(Date.now());

  function login(email, password) {
    return auth.signInWithEmailAndPassword(email, password);
  }

  function logout() {
    return auth.signOut();
  }

  // --- Idle detection logic ---
  const resetTimer = useCallback(() => {
    setLastActive(Date.now());
  }, []);

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'touchstart'];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    const checkIdle = setInterval(() => {
      if (currentUser && Date.now() - lastActive > IDLE_TIMEOUT) {
        console.warn('User idle for 80 minutes — logging out.');
        logout();
      }
    }, 30 * 1000); // check every 30 seconds

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      clearInterval(checkIdle);
    };
  }, [currentUser, lastActive, resetTimer]);

  // --- Firebase auth listener ---
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    login,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
